import { render, staticRenderFns } from "./MelosTabbar.vue?vue&type=template&id=46608072&scoped=true&"
import script from "./MelosTabbar.vue?vue&type=script&lang=ts&"
export * from "./MelosTabbar.vue?vue&type=script&lang=ts&"
import style0 from "./MelosTabbar.vue?vue&type=style&index=0&id=46608072&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46608072",
  null
  
)

export default component.exports